export const LOADER_DOTS = Array.from({ length: 6 });

export const LOADER_SIZES = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large",
} as const;

export const LOADER_TYPE = {
  DOT: "dot",
  SPINNER: "spinner",
} as const;

export const SPINNER_COLOR = {
  GREEN: "green",
  GRAY: "gray",
  DARK: "dark",
} as const;
